var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.login),expression:"!login"}],staticClass:"signup",on:{"click":_vm.signup}},[_vm._v(" sair ")]),_c('Header'),_c('v-main',[_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }